import { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export type TextButtonProps = Omit<ButtonProps, 'variant'>;

export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>((props, ref) => (
  <Button {...props} ref={ref} variant='text' />
));

TextButton.displayName = 'TextButton';
